define.alias("ember-cli-string-helpers/helpers/classify", "calendar/helpers/classify");